import Fnc from '../../library/Functions'
import Footer from '../../components/Footer';
import Header from '../../components/Header';

function EmptyBasket(props) {

  function handleClick() {
    window.location.href = Fnc.currEnv().businessHome;
    return null;
  }

  return (
    <>
      <Header />
      <div className="iol-checkout-body row">
        <div className="iol-checkout-left-part col-xl-7">
          <div className="iol-checkout-left">
            <div className="caption fucsia-text semibold">Il tuo carrello è vuoto</div>
            <div className="checkout-data-title semibold">Torna nella vetrina e scegli tra i prodotti della nostra offerta</div>
          </div>
          <button className="fucsia-button semibold" type="submit" onClick={() => { handleClick() }}>Torna al negozio</button>
        </div>
      </div>
      <Footer pageTitle="Carrello vuoto" />
    </>
  );
}

export default EmptyBasket;
